var map = {
	"./Review-orders.jpg": 166,
	"./Standing.svg": 167,
	"./WavingWithBag.svg": 85,
	"./actor-stepper/buyer-active.svg": 130,
	"./actor-stepper/buyer-completed.svg": 168,
	"./actor-stepper/check.svg": 363,
	"./actor-stepper/combined/buyer-view.svg": 364,
	"./actor-stepper/combined/default.svg": 365,
	"./actor-stepper/combined/finished.svg": 366,
	"./actor-stepper/combined/receiver-view.svg": 367,
	"./actor-stepper/combined/store-view.svg": 368,
	"./actor-stepper/receiver-active.svg": 169,
	"./actor-stepper/receiver-completed.svg": 170,
	"./actor-stepper/receiver-inactive.svg": 171,
	"./actor-stepper/store-active.svg": 172,
	"./actor-stepper/store-completed.svg": 173,
	"./actor-stepper/store-inactive.svg": 174,
	"./actors/buyer-green.svg": 369,
	"./actors/buyer.svg": 175,
	"./actors/emoji.svg": 370,
	"./actors/receiver-green.svg": 371,
	"./actors/receiver-grey.svg": 372,
	"./actors/receiver.svg": 176,
	"./actors/store-green.svg": 373,
	"./actors/store-grey.svg": 374,
	"./actors/store.svg": 177,
	"./bag.svg": 375,
	"./bag2.svg": 376,
	"./box-with-tag-min.svg": 106,
	"./boy-and-girl.svg": 178,
	"./boy/standing.svg": 179,
	"./boy/waving.svg": 180,
	"./clip.svg": 181,
	"./coffee_maker.svg": 182,
	"./dashboard.svg": 183,
	"./email.svg": 184,
	"./emoji.svg": 185,
	"./giftBox.svg": 107,
	"./girl_scanning.svg": 186,
	"./green-check.svg": 187,
	"./img/mockup-iphone-uruguay.png": 377,
	"./img/tag-background.png": 188,
	"./img/tag-proyecta-uruguay.png": 378,
	"./img/uruguay-logo.png": 379,
	"./iphoneMarcaBlanca.png": 189,
	"./key.svg": 190,
	"./logo-black.svg": 191,
	"./logo.svg": 192,
	"./mobile_only_v2.jpg": 380,
	"./no_qr.png": 193,
	"./nudge-prompt-to-desktop.png": 194,
	"./onboardingAssets/SD-logo-white.svg": 381,
	"./onboardingAssets/SDNewLogo.png": 195,
	"./onboardingAssets/backgrounds/cart/cart-01-EN.jpg": 196,
	"./onboardingAssets/backgrounds/cart/cart-01-PT.jpg": 197,
	"./onboardingAssets/backgrounds/cart/cart-01.jpg": 198,
	"./onboardingAssets/backgrounds/cart/cart-02-EN.jpg": 199,
	"./onboardingAssets/backgrounds/cart/cart-02-PT.jpg": 200,
	"./onboardingAssets/backgrounds/cart/cart-02.jpg": 201,
	"./onboardingAssets/backgrounds/cart/cart-03-EN.jpg": 202,
	"./onboardingAssets/backgrounds/cart/cart-03-PT.jpg": 203,
	"./onboardingAssets/backgrounds/cart/cart-03.jpg": 204,
	"./onboardingAssets/backgrounds/cart/cart-04-EN.jpg": 205,
	"./onboardingAssets/backgrounds/cart/cart-04-PT.jpg": 206,
	"./onboardingAssets/backgrounds/cart/cart-04.jpg": 207,
	"./onboardingAssets/backgrounds/cart/cart-05-EN.jpg": 208,
	"./onboardingAssets/backgrounds/cart/cart-05-PT.jpg": 209,
	"./onboardingAssets/backgrounds/cart/cart-05.jpg": 210,
	"./onboardingAssets/backgrounds/clouds/clouds.jpg": 111,
	"./onboardingAssets/backgrounds/dashboard/sd-dashboard.jpg": 112,
	"./onboardingAssets/backgrounds/dashboard/sd-print-EN.jpg": 211,
	"./onboardingAssets/backgrounds/dashboard/sd-print-PT.jpg": 212,
	"./onboardingAssets/backgrounds/dashboard/sd-print.jpg": 213,
	"./onboardingAssets/backgrounds/gmail/gmail-01.jpg": 113,
	"./onboardingAssets/backgrounds/mobile/bg-mobile.jpg": 382,
	"./onboardingAssets/backgrounds/mobile/mobile-EN.png": 383,
	"./onboardingAssets/backgrounds/mobile/mobile-PT.png": 384,
	"./onboardingAssets/backgrounds/mobile/mobile.png": 385,
	"./onboardingAssets/backgrounds/tiendanube-ventas/tn-ventas-01-EN.jpg": 214,
	"./onboardingAssets/backgrounds/tiendanube-ventas/tn-ventas-01-PT.jpg": 215,
	"./onboardingAssets/backgrounds/tiendanube-ventas/tn-ventas-01.jpg": 216,
	"./onboardingAssets/backgrounds/tiendanube-ventas/tn-ventas-02-EN.jpg": 217,
	"./onboardingAssets/backgrounds/tiendanube-ventas/tn-ventas-02-PT.jpg": 218,
	"./onboardingAssets/backgrounds/tiendanube-ventas/tn-ventas-02.jpg": 219,
	"./onboardingAssets/backgrounds/tiendanube-ventas/tn-ventas-03-EN.jpg": 220,
	"./onboardingAssets/backgrounds/tiendanube-ventas/tn-ventas-03-PT.jpg": 221,
	"./onboardingAssets/backgrounds/tiendanube-ventas/tn-ventas-03.jpg": 222,
	"./onboardingAssets/backgrounds/tiendanube-ventas/tn-ventas-04-EN.jpg": 386,
	"./onboardingAssets/carousel/carousel-01-indumentaria-femenina-pt.png": 387,
	"./onboardingAssets/carousel/carousel-01-indumentaria-femenina.png": 388,
	"./onboardingAssets/carousel/carousel-02-indumentaria-masculina-pt.png": 389,
	"./onboardingAssets/carousel/carousel-02-indumentaria-masculina.png": 390,
	"./onboardingAssets/carousel/carousel-03-ropa-bebes-pt.png": 391,
	"./onboardingAssets/carousel/carousel-03-ropa-bebes.png": 392,
	"./onboardingAssets/el.png": 108,
	"./onboardingAssets/ella.png": 109,
	"./onboardingAssets/mobile-EN.png": 223,
	"./onboardingAssets/mobile-PT.png": 224,
	"./onboardingAssets/mobile.png": 225,
	"./onboardingAssets/qr-bridge-dev.png": 264,
	"./onboardingAssets/qr-bridge-prod.png": 226,
	"./onboardingAssets/qr-bridge-stg.png": 265,
	"./onboardingAssets/vicky-wizard.png": 227,
	"./onboardingAssets/wizardIcons/cart-color-icon.png": 228,
	"./onboardingAssets/wizardIcons/gmail-color-icon.png": 229,
	"./onboardingAssets/wizardIcons/present-color-icon.png": 230,
	"./onboardingAssets/wizardIcons/printer-icon.png": 231,
	"./onboardingAssets/wizardIcons/success.png": 232,
	"./onboardingAssets/wizardIcons/thumbs-up.png": 233,
	"./play-icon-round.svg": 234,
	"./record.svg": 235,
	"./startup-chile.svg": 393,
	"./storydots-logo.svg": 236,
	"./storydots-white-logo.svg": 237,
	"./tag-startupchile.png": 238,
	"./video-background.png": 239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 362;